var map = {
	"./americanexpress.png": "66a3",
	"./bndes.png": "dbac",
	"./dinners.png": "d133",
	"./elo.png": "37aa",
	"./hipercard.png": "2e32",
	"./mastercard.png": "1b5c",
	"./other.png": "0256",
	"./sorocred.png": "01ce",
	"./visa.png": "b02d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7937";